import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src3242127264/src/toppan-voice-recorder-frontend/layouts/default.vue").then(m => m.default || m))
}